import {Children} from "react";
import {ErrorWithContext, MultipleLineError} from "@dvrt/graphql-widgets";
import {TableCell, TableRow as TableRowMUI, TableRowProps, Typography, styled} from "@mui/material";

type TableRowWithErrorsProps = TableRowProps & {
    errors?: ErrorWithContext[] | undefined;
};

const TableRow = styled(TableRowMUI)((_) => ({
    "& > *": {
        borderBottom: "unset",
        padding: CELL_PADDING,
    },
}));

const ErrorTypography = styled(Typography)(({theme}) => ({
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(12),
    paddingBottom: CELL_PADDING,
}));

const CELL_PADDING = 16 as const;

/**
 * A table row that can display multiline errors below the data row.
 * */
const TableRowWithErrors = ({errors, children, ...tableRowProps}: TableRowWithErrorsProps) => {
    const columnCount = Children.count(children);
    return (
        <>
            <TableRow {...tableRowProps}>{children}</TableRow>
            <TableRowMUI>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={columnCount}>
                    {errors && errors.length > 0 && (
                        <ErrorTypography>
                            <MultipleLineError errors={errors} />
                        </ErrorTypography>
                    )}
                </TableCell>
            </TableRowMUI>
        </>
    );
};

export default TableRowWithErrors;
